import { render, staticRenderFns } from "./CSelectPeriod.vue?vue&type=template&id=b5945072&scoped=true"
import script from "./CSelectPeriod.vue?vue&type=script&lang=js"
export * from "./CSelectPeriod.vue?vue&type=script&lang=js"
import style0 from "./CSelectPeriod.vue?vue&type=style&index=0&id=b5945072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5945072",
  null
  
)

export default component.exports